import { render, staticRenderFns } from "./contact-list-import-upload.vue?vue&type=template&id=7965d138&scoped=true&"
import script from "./contact-list-import-upload.vue?vue&type=script&lang=js&"
export * from "./contact-list-import-upload.vue?vue&type=script&lang=js&"
import style0 from "./contact-list-import-upload.vue?vue&type=style&index=0&id=7965d138&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7965d138",
  null
  
)

export default component.exports